import React from "react";
import PropTypes from "prop-types";

import { applicationShape } from "lib/propTypes";

import FinishCard from "./AlertCard/HomeAlertCardFinish";

const ResumeApp = ({ apps }) => (
    <section className="cand-home__resume-app-finish">
        <FinishCard apps={apps} />
        <div className="cand-home__resume-app-apply">
            <p>This space will get much more interesting once you&apos;ve applied to a few jobs!</p>
            <a href="/jobs/" className="finish-find-jobs">
                Find jobs
            </a>
        </div>
    </section>
);

ResumeApp.propTypes = {
    apps: PropTypes.arrayOf(PropTypes.shape(applicationShape)).isRequired,
};

export default ResumeApp;
